export default __webpack_public_path__ + "static/media/close_2.efcd5174.svg";